import React from 'react';
import { BrowserRouter} from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Web3ReactProvider } from '@web3-react/core'
import { ethers } from "ethers";

import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

function getLibrary(provider) {
    const library = new ethers.providers.Web3Provider(provider);
    library.pollingInterval = 8000; // frequency provider is polling
    return library;
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <Web3ReactProvider getLibrary={getLibrary}>
                    <App/>
                </Web3ReactProvider>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
